import React from 'react';
import { useObservableState } from 'observable-hooks';
import Button from '../form/Button';
import type { RegularButtonProps } from '../form/Button';
import type { SwarmFormController } from '../pages/measuringPoint/form-controller';
import LoadingSpinner from '../loadingSpinner/LoadingSpinner';

export type SaveLoadingButtonProps = RegularButtonProps & {
    formController: SwarmFormController;
    loadingKey?: string;
};

export function SaveLoadingButton({
    formController,
    children = gettext('SAVE'),
    loadingKey,
    disabled,
    ...props
}: SaveLoadingButtonProps) {
    const mainSaveIsInProgress = useObservableState(formController.mainSaveIsInProgress$);
    const privateNotesSaveIsInProgress = useObservableState(
        formController.privateNotesSaveIsInProgress$
    );
    const isDisabled = disabled || mainSaveIsInProgress || privateNotesSaveIsInProgress;
    const showLoadingSpinner =
        mainSaveIsInProgress && (!loadingKey || formController.activeSaveButtonKey === loadingKey);

    return (
        <Button {...props} disabled={isDisabled}>
            {showLoadingSpinner && <LoadingSpinner />}
            <span className="ml-1">{children}</span>
        </Button>
    );
}
